import React, { memo } from 'react';
import './LoadingAccordion.scss';
import { Loading } from '@web-components-proxy';

export const LoadingAccordion = memo(() => {
	return (
		<div className="accordion-loading">
			<Loading class="accordion-loading__spinner" loader-size="small" active={true} cover={false} />
		</div>
	);
});
